import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

const KEY = "cookie_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(KEY)) return;
    const t = setTimeout(() => setShow(true), 1000);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const open = () => setShow(true);
    window.addEventListener("cookie:open", open);
    return () => window.removeEventListener("cookie:open", open);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", { analytics_storage: value === "accepted" ? "granted" : "denied" });
    }
    if (typeof window.fbq === "function") {
      window.fbq("consent", value === "accepted" ? "grant" : "revoke");
      if (value === "accepted") window.fbq("track", "PageView");
    }
    window.dispatchEvent(new Event("cookie:decided"));
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          className="fixed z-[80] bottom-0 left-0 right-0 bg-ink text-bone border-t border-bone/10"
        >
          <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row md:items-center gap-4 md:justify-between">
            <p className="text-sm text-bone/70 max-w-2xl leading-relaxed">
              Utilizziamo cookie tecnici necessari al funzionamento del sito e, previo tuo consenso, cookie volti a migliorare la tua esperienza. Per maggiori informazioni consulta la{" "}
              <Link to="/privacy" className="underline text-bone hover:text-claret transition-colors">Privacy &amp; Cookie Policy</Link>.
            </p>
            <div className="flex gap-3 shrink-0">
              <button data-testid="cookie-reject" onClick={() => decide("rejected")} className="border border-bone/30 hover:border-bone px-6 min-h-[44px] text-xs uppercase tracking-[0.15em] transition-colors">Rifiuta</button>
              <button data-testid="cookie-accept" onClick={() => decide("accepted")} className="bg-claret hover:bg-claret-dark text-bone px-6 min-h-[44px] text-xs uppercase tracking-[0.15em] transition-colors">Accetta</button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
